module.exports = __webpack_public_path__ + "img/logo-school-14.5ea62076.png";